var _path, _circle, _path2, _circle2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 132,
    viewBox: "0 0 64 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 88H0V132H64V88Z",
    fill: "#3C82F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 23,
    r: 9.25,
    stroke: "#50595F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 27.7273L31.3352 21.4545H32.3239L32.4091 27.7273H31.25ZM31.8295 18.9318C32.0398 18.9318 32.2202 19.0071 32.3707 19.1577C32.5213 19.3082 32.5966 19.4886 32.5966 19.6989C32.5966 19.9091 32.5213 20.0895 32.3707 20.2401C32.2202 20.3906 32.0398 20.4659 31.8295 20.4659C31.6193 20.4659 31.4389 20.3906 31.2884 20.2401C31.1378 20.0895 31.0625 19.9091 31.0625 19.6989C31.0625 19.5597 31.098 19.4318 31.169 19.3153C31.2372 19.1989 31.3295 19.1051 31.446 19.0341C31.5597 18.9659 31.6875 18.9318 31.8295 18.9318Z",
    fill: "#50595F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 110,
    r: 9.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 114.727L31.3352 108.455H32.3239L32.4091 114.727H31.25ZM31.8295 105.932C32.0398 105.932 32.2202 106.007 32.3707 106.158C32.5213 106.308 32.5966 106.489 32.5966 106.699C32.5966 106.909 32.5213 107.089 32.3707 107.24C32.2202 107.391 32.0398 107.466 31.8295 107.466C31.6193 107.466 31.4389 107.391 31.2884 107.24C31.1378 107.089 31.0625 106.909 31.0625 106.699C31.0625 106.56 31.098 106.432 31.169 106.315C31.2372 106.199 31.3295 106.105 31.446 106.034C31.5597 105.966 31.6875 105.932 31.8295 105.932Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_33)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 66,
    r: 9.25,
    stroke: "url(#paint0_linear_2_33)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 70.7273L31.3352 64.4545H32.3239L32.4091 70.7273H31.25ZM31.8295 61.9318C32.0398 61.9318 32.2202 62.0071 32.3707 62.1577C32.5213 62.3082 32.5966 62.4886 32.5966 62.6989C32.5966 62.9091 32.5213 63.0895 32.3707 63.2401C32.2202 63.3906 32.0398 63.4659 31.8295 63.4659C31.6193 63.4659 31.4389 63.3906 31.2884 63.2401C31.1378 63.0895 31.0625 62.9091 31.0625 62.6989C31.0625 62.5597 31.098 62.4318 31.169 62.3153C31.2372 62.1989 31.3295 62.1051 31.446 62.0341C31.5597 61.9659 31.6875 61.9318 31.8295 61.9318Z",
    fill: "url(#paint1_linear_2_33)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_33",
    x: 18,
    y: 56,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_33"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_33",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_33",
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_33",
    x1: 32,
    y1: 74,
    x2: 32,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2ebe7a27ec9e1e828707b0f4e0968732.svg";
export { ForwardRef as ReactComponent };